module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vrepr18-c9815b1f2ff638e29d7c68c75e833b99.jpg";